import * as React from 'react';
import { Link } from 'react-static';

import Button, { Props as ButtonProps } from './Button';

export interface LinkComponentProps {
  className: string;
}

interface LinkButtonProps extends ButtonProps {
  type?: undefined;
  disabled?: undefined;
  to: string;
  replace?: boolean;
  scrollToTop?: boolean;
  target?: string;
  rel?: string;
  download?: boolean;
}

const LinkButton: React.SFC<LinkButtonProps> = ({
  children,
  to,
  replace,
  scrollToTop,
  onClick,
  target,
  rel,
  download,
  ...buttonProps
}) => (
  <Button
    Link={linkProps =>
      download ? (
        <a href={to} download className={linkProps.className}>
          {linkProps.children}
        </a>
      ) : (
        <Link
          to={to}
          target={target}
          rel={rel}
          replace={replace}
          className={linkProps.className}
          scrollToTop={scrollToTop}
          onClick={onClick}
        >
          {linkProps.children}
        </Link>
      )
    }
    {...buttonProps}
  >
    {children}
  </Button>
);

export default LinkButton;



// WEBPACK FOOTER //
// /www/client/src/components/Button/LinkButton.tsx